import axios from "axios";
import { useState } from "react";

import Marketing from "./components/body/Martketing";
import OrderDetails from "./components/body/Order";
import Footer from "./components/main/Footer";
import Header from "./components/main/Header";
import Hero from "./components/main/Hero";
import Spinner from "./components/UI/Spinner";
import AuthAlert from "./components/UI/AuthAlert";

function App() {
  const [shipment, setShipment] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertStatus, setAlertStatus] = useState(false);

  async function fetchData(trackingId) {
    setShowSpinner(true);
    const url = `${process.env.REACT_APP_API_URL}${trackingId}`;
    try {
      const res = await axios.get(url);
      console.log(res);

      if (res.data.status === "success") {
        setShipment(res.data.data.shipment);
        setAlertMsg("Review your tracking and order details below");
        setAlertStatus(true);
        setShowAlert(true);
      } else {
        setShipment(null);
        setAlertMsg(res.message);
        setAlertStatus(false);
        setShowAlert(true);
      }
    } catch (error) {
      setShipment(null);
      setAlertMsg("No shipment found with that tracking number.");
      setAlertStatus(false);
      setShowAlert(true);
    }

    setTimeout(() => {
      setShowSpinner(false);
      setShowAlert(false);
    }, 3000);
  }
  return (
    <>
      {showAlert && <AuthAlert message={alertMsg} status={alertStatus} />}
      <Header />
      <div className="hero">
        {showSpinner && <Spinner />}
        <Hero fetchData={fetchData} />
      </div>
      {shipment && <OrderDetails shipment={shipment} />}
      <Marketing />
      <Footer />
    </>
  );
}

export default App;
